/**
 * Artinci — 21-Day Reset landing section
 * Progressive enhancement only: scroll fade-up, sequential tracker fill,
 * sticky bottom CTA reveal. Everything is already visible/legible without
 * this file (see the .no-js rules in reset-landing.css.liquid).
 */
(function () {
  'use strict';

  function initReset(root) {
    root.classList.remove('no-js');

    var reduceMotion = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var reveals = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    var tracker = root.querySelector('[data-tracker]');
    var tiles = tracker ? Array.prototype.slice.call(tracker.querySelectorAll('.reset-tracker__tile')) : [];
    var hero = root.querySelector('[data-hero]');
    var sticky = root.querySelector('.reset-sticky');

    var filled = false;
    var timers = [];
    var poll = null;

    function revealAll() {
      reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      reveals.length = 0;
    }

    function fillAllInstant() {
      tiles.forEach(function (tile) { tile.classList.add('is-filled'); });
      filled = true;
    }

    function startFill() {
      if (filled) return;
      filled = true;
      tiles.forEach(function (tile, i) {
        timers.push(setTimeout(function () {
          tile.classList.add('is-filled');
        }, 140 + (i + 1) * 62));
      });
    }

    if (reduceMotion) {
      revealAll();
      fillAllInstant();
    }

    function check() {
      var vh = window.innerHeight || document.documentElement.clientHeight;

      for (var i = reveals.length - 1; i >= 0; i--) {
        var r = reveals[i].getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) {
          reveals[i].classList.add('is-revealed');
          reveals.splice(i, 1);
        }
      }

      if (tracker && !filled) {
        var gr = tracker.getBoundingClientRect();
        if (gr.top < vh * 0.85 && gr.bottom > 0) startFill();
      }

      if (hero && sticky) {
        var hr = hero.getBoundingClientRect();
        sticky.classList.toggle('is-visible', hr.bottom < 40);
      }

      if (reveals.length === 0 && filled && poll) {
        clearInterval(poll);
        poll = null;
      }
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    if (!reduceMotion) poll = setInterval(check, 250);
    requestAnimationFrame(check);
  }

  function init() {
    var roots = document.querySelectorAll('.reset-landing');
    for (var i = 0; i < roots.length; i++) initReset(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
